<template>
	<section v-if="items.length" class="main-content contentblocks">
		<slot name="blocks-header" />
		<content-block
			v-for="item in items"
			:key="item.ID"
			:image="item.image"
			:image-webp="item.imageWebp ?? ''"
			:image-alt="item.imageAlt ?? ''"
			:header="item.header"
			:content="item.content"
			class="row contentblock fade-animate fade-up"
		/>
		<div class="fine-bg-pattern" />
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.contentblocks {
	background: var(--primary-background-color);
	position: relative;
	padding: 50px 0;
}

.fine-bg-pattern {
	position: absolute;
	inset: 0;
	width: 100%;
	z-index: 1;
	opacity: 0.9;
}
</style>
